import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {Platform} from '@ionic/angular';
import {SplashScreen} from '@capacitor/splash-screen';
import {StatusBar} from '@capacitor/status-bar';
import {registerLocaleData} from '@angular/common';
import localeES from '@angular/common/locales/es';
import {NavigationKeys} from './utils/navigationkeys';

registerLocaleData(localeES, 'es');

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})

export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private platform: Platform
  ) {
    platform.ready().then(() => {
    /*  TextZoom.get().then((res: GetResult)=>{
        let currentZoom = res.value;
        if(currentZoom > 1.2){
          let options: SetOptions = {
            value: 1.2
          };
          TextZoom.set(options);
        }
      });

      console.log("textZoom",TextZoom.get());*/
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      StatusBar.setBackgroundColor({color: "#057bff"}).catch(() => {
      });
      setTimeout(() => {
        SplashScreen.hide({
          fadeOutDuration: 400,
        });
      }, 2000);
    });

    let isNew = localStorage.getItem('isNew');

    if (isNew !== '0') {
      this.router.navigate([NavigationKeys.TUTORIAL]);
    }

    this.initializeApp();
  }

  async ngOnInit() {
  }

  initializeApp() {
    this.translate.setDefaultLang('es'); // add this
    this.translate.addLangs(['es', 'en']);
    let find = this.translate
      .getLangs()
      .find((elem) => elem === navigator.language);

    if (find) {
      this.translate.use(find);
    } else {
      let splitLang = navigator.language.split('-')[0];
      find = this.translate.getLangs().find((elem) => elem === splitLang);

      if (find) {
        this.translate.use(find);
      } else {
        this.translate.use(this.translate.getDefaultLang());
      }
    }
  }
}
